import React, { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { SignOut, Package, FileText, Newspaper, Users, Cloud, MegaphoneSimple, Briefcase, Globe, CurrencyInr, House, Image as ImageIcon } from "@phosphor-icons/react";
import api from "@/lib/api";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: House, end: true },
  { to: "/admin/leads", label: "Leads", icon: Users },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/web-packages", label: "Web packages", icon: FileText },
  { to: "/admin/hosting-plans", label: "Hosting", icon: Cloud },
  { to: "/admin/marketing-tiers", label: "Marketing", icon: MegaphoneSimple },
  { to: "/admin/case-studies", label: "Case studies", icon: FileText },
  { to: "/admin/insights", label: "Insights / Blog", icon: Newspaper },
  { to: "/admin/careers", label: "Careers", icon: Briefcase },
  { to: "/admin/global-reach", label: "Global reach", icon: Globe },
  { to: "/admin/currency", label: "Currency", icon: CurrencyInr },
  { to: "/admin/media", label: "Media", icon: ImageIcon },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const t = localStorage.getItem("maxine_admin_token");
    if (!t) { nav("/admin/login", { replace: true }); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => nav("/admin/login", { replace: true }));
  }, [nav]);

  const logout = () => {
    localStorage.removeItem("maxine_admin_token");
    localStorage.removeItem("maxine_admin_user");
    nav("/admin/login");
  };

  return (
    <div data-testid="admin-shell" className="min-h-screen bg-[color:var(--paper-alt)] flex">
      <aside className="w-64 shrink-0 bg-white border-r border-[color:var(--line)] h-screen sticky top-0 flex flex-col">
        <div className="p-5 border-b border-[color:var(--line)] flex items-center gap-2">
          <img src="/logo-maxine.png" alt="Maxine" className="h-8 w-auto" />
          <span className="font-mono text-[9px] uppercase tracking-widest text-neutral-500 ml-auto">admin</span>
        </div>
        <nav className="flex-1 overflow-auto py-4">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-5 py-2.5 text-sm border-l-2 transition-colors duration-150 ${
                  isActive ? "border-[color:var(--brand)] bg-neutral-50 text-black font-semibold" : "border-transparent text-neutral-600 hover:bg-neutral-50 hover:text-black"
                }`
              }
            >
              <l.icon size={16} weight="bold" />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-[color:var(--line)]">
          {user && <div className="text-xs text-neutral-500 mb-3 truncate" data-testid="admin-user-email">{user.email}</div>}
          <div className="flex items-center gap-2">
            <Link to="/" className="flex-1 btn-ghost justify-center text-xs py-2">View site</Link>
            <button onClick={logout} data-testid="admin-logout" className="btn-brand text-xs py-2 px-3">
              <SignOut size={14} weight="bold" />
            </button>
          </div>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
